import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react'
import { useMapDataStore } from '../hooks/useMapDataStore'

interface MapDataContextValue {
  waypoints: any[]
  routes: any[]
  updateWaypoints: (waypoints: any[]) => void
  updateRoutes: (routes: any[]) => void
}

const MapDataContext = createContext<MapDataContextValue | null>(null)

interface MapDataProviderProps {
  children: ReactNode
}

/**
 * Provider for stable map data (waypoints, routes)
 * Separates map data from panel state to prevent unnecessary layer updates
 */
export function MapDataProvider({ children }: MapDataProviderProps) {
  const { waypoints, routes, updateWaypoints, updateRoutes } = useMapDataStore()

  return (
    <MapDataContext.Provider value={{ waypoints, routes, updateWaypoints, updateRoutes }}>
      {children}
    </MapDataContext.Provider>
  )
}

/**
 * Hook to access map data context
 */
export function useMapDataContext(): MapDataContextValue {
  const context = useContext(MapDataContext)
  if (!context) {
    throw new Error('useMapDataContext must be used within MapDataProvider')
  }
  return context
}

